import { Barcode, Timer, Stop, GearSix, X } from "@phosphor-icons/react";
import { barcodeSupported } from "../lib/useBarcodeScan";

// Row of capture modes above the shutter: SKU chip, camera scan, timelapse, settings.
export function CaptureModesBar({ sku, onClearSku, scanOn, onToggleScan, tl, onToggleTl, settings, onOpenSettings, disabled }) {
  const btn = "h-9 px-2.5 border-2 flex items-center gap-1.5 font-mono text-[11px] font-bold active:scale-[0.96] disabled:opacity-40";
  return (
    <div className="px-3 pt-3 flex items-center gap-2 overflow-x-auto no-scrollbar" data-testid="capture-modes-bar">
      <button onClick={onOpenSettings} className={`${btn} shrink-0 bg-black text-white border-white/60`} data-testid="camera-settings-btn" aria-label="Capture settings">
        <GearSix size={16} weight="bold" />
      </button>
      {sku ? (
        <span className="h-9 pl-2.5 pr-1 border-2 border-[#FF2A2A] bg-[#FF2A2A] text-white flex items-center gap-1.5 font-mono text-[11px] font-bold shrink-0" data-testid="camera-sku-chip">
          SKU {sku}
          <button onClick={onClearSku} className="w-6 h-6 flex items-center justify-center bg-black/30" aria-label="Clear SKU" data-testid="camera-sku-clear">
            <X size={12} weight="bold" />
          </button>
        </span>
      ) : (
        <span className="h-9 px-2.5 border-2 border-dashed border-white/40 flex items-center font-mono text-[10px] opacity-70 shrink-0" data-testid="camera-sku-empty">
          SCAN A BARCODE TO TAG
        </span>
      )}
      {barcodeSupported && (
        <button onClick={onToggleScan} disabled={disabled} data-testid="camera-scan-toggle"
          className={`${btn} shrink-0 ${scanOn ? "bg-white text-black border-white" : "bg-black text-white border-white/60"}`}>
          <Barcode size={16} weight="bold" /> {scanOn ? "SCANNING" : "CAM SCAN"}
        </button>
      )}
      <button onClick={onToggleTl} disabled={disabled && !tl.running} data-testid="camera-timelapse-btn"
        className={`${btn} shrink-0 ${tl.running ? "bg-[#FF2A2A] text-white border-[#FF2A2A]" : "bg-black text-white border-white/60"}`}>
        {tl.running ? <Stop size={16} weight="fill" /> : <Timer size={16} weight="bold" />}
        {tl.running
          ? <span data-testid="camera-timelapse-progress">{tl.taken}{settings.tlShots ? `/${settings.tlShots}` : ""} · STOP</span>
          : `TIMELAPSE ${settings.tlIntervalS}s`}
      </button>
    </div>
  );
}
